
export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 150 },
   { key: '2', headerName: 'License', field: 'license_name', hide: false, width: 350 },
//  { key: '3', headerName: 'Renewal', field: 'Renewal', hide: false, width: 350 },
//  { key: '3', headerName: 'Renewal', field: 'Renewal', hide: false, width: 350 },
  { key: '4', headerName: 'Status', field: 'status', hide: false, width: 300 },
  //{ key: '5', headerName: 'Escalation_mail_two', field: 'Escalation_mail_two', hide: false, width: 400 },
];
